export default function (defaults, extras) {
  const resolvedDefaults = defaults || {};
  const resolvedExtras = extras || {};
  return Object.keys(resolvedDefaults).concat(Object.keys(resolvedExtras)).reduce((acc, val) => {
    acc[val] = resolvedExtras[val] === undefined ? resolvedDefaults[val] : resolvedExtras[val];
    return acc;
  }, {});
}
